import styled from 'styled-components';
import { PaymentMethodType } from '../api/types';
import mastercard from '../../../assets/images/mastercard.png';
import visa from '../../../assets/images/visa.png';

type PaymentDetailsProps = {
  paymentDetail: PaymentMethodType;
};

export const PaymentDetails = ({ paymentDetail }: PaymentDetailsProps) => {
  if (!paymentDetail.card_brand || !paymentDetail.last4) return null;
  return (
    <Container>
      <CardsWrapper>
        <StyledCard
          src={paymentDetail.card_brand === 'mastercard' ? mastercard : visa}
          alt={paymentDetail.card_brand}
        />
        {paymentDetail.is_expired && (
          <ExpiredLabel>
            <p>Expired</p>
          </ExpiredLabel>
        )}
      </CardsWrapper>
      <BottomSection>
        <CardNumber>**** **** **** {paymentDetail.last4}</CardNumber>
        <ExpireWrapper isExpired={paymentDetail.is_expired}>
          <p>
            Expires {paymentDetail.exp_month}/{paymentDetail.exp_year}
          </p>
        </ExpireWrapper>
        {paymentDetail.is_default_for_subscription && <DefaultLabel>Default</DefaultLabel>}
      </BottomSection>
    </Container>
  );
};

const DefaultLabel = styled.span`
  align-self: flex-start;
  margin-top: 0.25rem;
  padding: 0.1rem 0.4rem;
  border-radius: 0.375rem;
  background: ${({ theme }) => theme.colors.primary}15;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

const ExpiredLabel = styled.div`
  display: flex;
  gap: 0.5rem;
  border-radius: 0.375rem;
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.red}, ${({ theme }) => theme.colors.red}90);
  font-size: 0.6rem;
  padding: 0.2rem 0.4rem;
  align-items: center;
  color: ${({ theme }) => theme.colors.white};
  position: absolute;
  bottom: -8px;
  right: -8px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  border: 2px solid white;
`;

const CardNumber = styled.p`
  font-size: ${({ theme }) => theme.fontSize.extraSmall};
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const ExpireWrapper = styled.div<{ isExpired: boolean }>`
  font-size: ${({ theme }) => theme.fontSize.extraSmall};
  color: ${({ theme, isExpired }) => theme.colors[isExpired ? 'red' : 'gray500']};
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.white}, ${({ theme }) => theme.colors.gray}15);
  border: 1px solid ${({ theme }) => theme.colors.gray500}20;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    border-color: ${({ theme }) => theme.colors.primary}30;
  }
`;

const CardsWrapper = styled.div`
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.gray}80, ${({ theme }) => theme.colors.gray}60);
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  position: relative;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
`;
const StyledCard = styled.img`
  width: 3rem;
`;
